import React from 'react';
import classNames from 'classnames';
import { SecondaryButton } from '../../../components';
import { useHistory } from 'react-router-dom';
import { FEATURED_CATEGORIES } from '../../../util/enums';

import css from './Section.module.css';

/**
 * Category config
 * searchParams -> exact search page query params
 * label -> button text
 * img -> image to display
 */
const LANDING_CATEGORY_IDS = ['tiles', 'mats', 'racks', 'accessories_and_gifts', 'shop_new'];
const CATEGORY_CONFIG = LANDING_CATEGORY_IDS.map(id =>
  FEATURED_CATEGORIES.find(category => category.id === id)
).filter(Boolean);

function ExploreSection() {
  const history = useHistory();

  const goToCategory = searchParams => {
    const params = new URLSearchParams(searchParams);
    history.push({
      pathname: '/s',
      search: params.toString(),
    });
  };

  return (
    <div className={classNames(css.popularSessions, css.sectionPadding, css.justInSec)}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          {/* <span>Ready to Buy?</span> */}
          <h2>Shop by Category</h2>
        </div>

        <div className={css.sectionListings}>
          {/* If you want a slider later, wrap CATEGORY_CONFIG.map inside <Slider {...sliderSettings}> */}
          {CATEGORY_CONFIG.map(cat => (
            <div
              key={cat.id}
              className={css.categoryBlock}
              onClick={() => goToCategory(cat.searchParams)}
            >
              <div className={css.categoryImg}>
                <img src={cat.imgUrl} alt={cat.alt} />
              </div>
              <div className={css.categoryInfo}>
                <SecondaryButton>{cat.landingLabel}</SecondaryButton>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ExploreSection;
